// import React from "react";
import "./Home.css"; // Add styles here
import homeImg from "../resources/home-img.png";
import { Link, useNavigate } from "react-router-dom";
// import Buy from "../resources/basket-dollar.svg";
// import Risk from "../resources/alert-hexagon.svg";
import Calculator from "../resources/calculator.svg";
// import Pay from "../resources/credit-card-pay.svg";
// import Download from "../resources/download.svg";
// import Fitness from "../resources/report-money.svg";
import FinancialPlanning from "../resources/financial-planning.jpg";
// import General from "../resources/general-insurance.jpg";
import Tax from "../resources/tax-planning.jpg";
// import Child from "../resources/child-marriage.jpg";
// import Education from "../resources/education-planning.jpg";
// import Retirement from "../resources/retirement.jpg";
// import Research from "../resources/research.jpg";
import Estate from "../resources/estate-planning.jpg";
import MutualFunds from "../resources/account.jpg";
// import LifeInsurance from "../resources/life-insurance.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
// import BlogPreviewCarousel from "../components/BlogPreviewCarousel";
// import StatutoryWarningPreviewCarousel from "../components/StatutoryWarningPreviewCarousel";
import testimonial1 from "../resources/testimonial1.jpg";
import testimonial2 from "../resources/testimonial2.png";
import testimonial3 from "../resources/testimonial3.png";
import testimonial4 from "../resources/testimonial4.png";
import TradingViewChart from "../components/TradingViewChart";
import Typewriter from "typewriter-effect";
import logo1 from "../resources/partners/logo1.jpg";
import logo2 from "../resources/partners/logo2.png";
import logo3 from "../resources/partners/logo3.png";
import logo4 from "../resources/partners/logo4.jpg";
import logo5 from "../resources/partners/logo5.jpg";
import logo6 from "../resources/partners/logo6.png";
import logo7 from "../resources/partners/logo7.png";
import logo8 from "../resources/partners/logo8.png";
import logo9 from "../resources/partners/logo9.png";
import logo10 from "../resources/partners/logo10.jpg";
import logo11 from "../resources/partners/logo11.png";
import logo12 from "../resources/partners/logo12.png";
import logo13 from "../resources/partners/logo13.jpg";
import logo14 from "../resources/partners/logo14.jpeg";
import logo15 from "../resources/partners/logo15.jpg";
import logo16 from "../resources/partners/logo16.png";
import logo17 from "../resources/partners/logo17.png";
import logo18 from "../resources/partners/logo18.png";
import logo19 from "../resources/partners/logo19.jpg";
import logo20 from "../resources/partners/logo20.jpeg";
import logo21 from "../resources/partners/logo21.png";
import logo22 from "../resources/partners/logo22.png";
import logo23 from "../resources/partners/logo23.png";
import logo24 from "../resources/partners/logo24.jpg";
import logo25 from "../resources/partners/logo25.jpg";
import logo26 from "../resources/partners/logo26.png";
import logo27 from "../resources/partners/logo27.png";
import logo28 from "../resources/partners/logo28.jpg";
import logo29 from "../resources/partners/logo29.png";
import logo30 from "../resources/partners/logo30.png";
import logo31 from "../resources/partners/logo31.png";
import logo32 from "../resources/partners/logo32.png";
import logo33 from "../resources/partners/logo33.png";
import logo34 from "../resources/partners/logo34.jpg";
import logo35 from "../resources/partners/logo35.jpg";
import logo36 from "../resources/partners/logo36.png";

const Home = () => {
  const navigate = useNavigate();
  const logos = [
    logo1,
    logo2,
    logo3,
    logo4,
    logo5,
    logo6,
    logo7,
    logo8,
    logo9,
    logo10,
    logo11,
    logo12,
    logo13,
    logo14,
    logo15,
    logo16,
    logo17,
    logo18,
    logo19,
    logo20,
    logo21,
    logo22,
    logo23,
    logo24,
    logo25,
    logo26,
    logo27,
    logo28,
    logo29,
    logo30,
    logo31,
    logo32,
    logo33,
    logo34,
    logo35,
    logo36,
  ];
  const features = [
    {
      id: 2,
      heading: "Financial Calculator",
      description: "Click here to access SIP calculator",
      thumbnailImage: Calculator,
      route: "/financial-calculator",
    },
    // {
    //   id: 2,
    //   heading: "Download Form",
    //   description: "Access various forms for future freedom planning needs.",
    //   thumbnailImage: Download,
    //   route: "https://dea.gov.in/forms/downloadable",
    // },
    // {
    //   id: 3,
    //   heading: "Buy MF Online",
    //   description: "Want to Invest in Mutual Funds? We are here for you.",
    //   thumbnailImage: Buy,
    //   route: "https://www.mfonline.co.in/",
    // },
    // {
    //   id: 4,
    //   heading: "Financial Fitness",
    //   description: "Check your Financial Fitness in a user-friendly manner.",
    //   thumbnailImage: Fitness,
    //   route: "https://economictimes.indiatimes.com/wealth/financialfitness",
    // },
    // {
    //   id: 5,
    //   heading: "Risk Profile",
    //   description: "Calculate your Risk Taking capacity with this tool.",
    //   thumbnailImage: Risk,
    //   route: "https://www.utimf.com/risk-analyser-calculator",
    // },
    // {
    //   id: 6,
    //   heading: "Pay Premium Online",
    //   description:
    //     "Pay your Life-Insurance premium of any insurance company here.",
    //   thumbnailImage: Pay,
    //   route: "https://licindia.in/premium-payment",
    // },
  ];

  const settings = {
    dots: true,
    centerPadding: "60px",
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 2000,
    cssEase: "ease",
    centerMode: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const partnerSettings = {
    centerPadding: "60px",
    infinite: true,
    slidesToShow: 10,
    slidesToScroll: 5,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 2000,
    cssEase: "ease",
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  return (
    <div className="home">
      <div className="hero">
        <div className="hero-content">
          <h1 className="main-heading">Welcome To</h1>
          <h1 className="main-heading">
            <Typewriter
              options={{
                strings: ["United Investment Point"],
                autoStart: true,
                loop: true,
              }}
            />
          </h1>
          <p className="main-content">
            Empowering Your Financial Journey, One Step at a Time.
          </p>
          <button className="button">Learn More</button>
        </div>
        <img alt="home-img" src={homeImg}></img>
      </div>

      {/* Features Section */}
      <section className="features">
        <h3 className="heading">Features</h3>
        <p className="intro">
          We believe to educate and aware investors with the help of Investor
          Awareness Programme (IAPs) and by providing below facilities specially
          to our clients.
        </p>
        <div className="feature-cards">
          {features.map((feature) => (
            <div className="cookie-card" key={feature.id}>
              <img
                id="cookieSvg"
                src={feature.thumbnailImage}
                alt={feature.heading}
                className="feature-icon"
              />
              <p className="cookieHeading">{feature.heading}</p>
              <p className="cookieDescription">
                {feature.description}
                <br />
                <br />
                <Link
                  to={feature.route}
                  target={
                    feature.route === "/financial-calculator"
                      ? "_self"
                      : "_blank"
                  }
                  className="read-more"
                >
                  Learn More
                </Link>
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* About Section */}
      <div className="about-market">
        <section className="about">
          <h2 className="heading">About Us</h2>
          <p className="intro">
            Financial goals are a part of everyone's life—whether it's buying a
            home, saving for a child's education, or preparing for retirement.
            Achieving these goals requires careful planning, minimizing tax
            liabilities, and consistently building wealth to ensure financial
            security when it matters most.
          </p>
          <p className="intro">
            At <b className="services-bold">United Investment Point</b>, our
            mission is to educate, guide, and support our clients in making
            smart investment choices that not only help them achieve their
            financial objectives but also provide a safety net during unforeseen
            emergencies. Trust us with your future freedom planning, and enjoy
            peace of mind as we take responsibility for your financial success,
            allowing you to focus on what truly matters.
          </p>
          <button
            className="button"
            onClick={() => {
              navigate("/about");
            }}
          >
            Read More
          </button>
        </section>
        <section className="market">
          <h2 className="heading">Market Overview</h2>
          <p className="intro"></p>
          <div className="chart-container">
            <TradingViewChart />
          </div>
        </section>
      </div>

      <section className="services">
        <h2 className="heading">Our Services</h2>
        <div className="articles">
          <Slider {...settings}>
            {[
              {
                id: 1,
                heading: "Future Freedom Planning",
                description:
                  "Plan your finances effectively to achieve your short and long-term goals with expert guidance.",
                thumbnailImage: FinancialPlanning,
                route: "/services/future-freedom-planning",
              },
              {
                id: 2,
                heading: "Mutual Funds",
                description:
                  "Diversify your portfolio and grow wealth with our curated mutual fund options.",
                thumbnailImage: MutualFunds,
                route: "/services/mutual-funds",
              },
              {
                id: 3,
                heading: "Estate Guidance",
                description:
                  "Ensure smooth transfer of wealth and assets to your loved ones with expert estate guidance advice.",
                thumbnailImage: Estate,
                route: "/services/estate-guidance",
              },
              {
                id: 4,
                heading: "Tax Guidance",
                description:
                  "Minimize your tax liabilities and maximize savings with our tax guidance strategies.",
                thumbnailImage: Tax,
                route: "/services/tax-guidance",
              },
            ].map((service) => (
              <article key={service.id}>
                <div className="article-wrapper">
                  <figure>
                    <img src={service.thumbnailImage} alt={service.heading} />
                  </figure>
                  <div className="article-body">
                    <h2>{service.heading}</h2>
                    <p>{service.description}</p>
                    <Link to={service.route} className="read-more">
                      Learn More{" "}
                      <span className="sr-only">about {service.heading}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </Slider>
        </div>
        <button
          className="button"
          onClick={() => {
            navigate("/services");
          }}
        >
          More...
        </button>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <h3 className="heading">What Our Clients Say</h3>
        <p className="intro">
          Curious about the real-world impact of our work? Explore the inspiring
          stories of individuals who have benefited from our solutions. Their
          testimonials showcase the versatility and effectiveness of our
          approach."
        </p>
        <div class="wrapper">
          <div class="box">
            <svg
              className="quote"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z" />
            </svg>
            <p>
              I have relied on United Investment Point for various personal and
              financial needs over the years, and I have always been impressed
              with the quality and value of their advisory services. The team
              delivers services with exceptional competence and professionalism.
              I highly recommend them for anyone seeking reliable financial
              support.
            </p>
            <div class="content">
              <div class="info">
                <div class="name">Pradeep Singh</div>
                <div class="job">Senior Manager | HDFC Life</div>
              </div>
              <div class="image">
                <img src={testimonial1} alt="" />
              </div>
            </div>
          </div>
          <div class="box">
            <svg
              className="quote"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z" />
            </svg>
            <p>
              I have been with United Investment Point Advisors for years and
              always had great service. The team is patient, helpful, and
              explains things clearly. They truly care about their clients and
              provide reliable advice. I highly recommend them.
            </p>
            <div class="content">
              <div class="info">
                <div class="name">Sandesh Tripathi</div>
                <div class="job">
                  Assistant Professor | Birla Institute of Applied Sciences
                </div>
              </div>
              <div class="image">
                <img src={testimonial3} alt="" />
              </div>
            </div>
          </div>
          <div class="box">
            <svg
              className="quote"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z" />
            </svg>
            <p>
              I have been incredibly impressed with the professionalism and
              expertise shown by the team. They truly care about their clients
              and go the extra mile to ensure satisfaction. The insights and
              advice provided have been invaluable.
            </p>
            <div class="content">
              <div class="info">
                <div class="name">Rohit Srivastava</div>
                <div class="job">Medical Professional</div>
              </div>
              <div class="image">
                <img src={testimonial2} alt="" />
              </div>
            </div>
          </div>
          <div class="box">
            <svg
              className="quote"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z" />
            </svg>
            <p>
              United Investment Point has been my go-to for personal and
              financial needs, and their services have always exceeded my
              expectations. The team is highly skilled, professional, and
              consistently delivers excellent advice and support. I highly
              recommend their services to anyone looking for trustworthy
              financial guidance.
            </p>
            <div class="content">
              <div class="info">
                <div class="name">S.P.R. Tripathi</div>
                <div class="job">Ex UP Govt Employee</div>
              </div>
              <div class="image">
                <img src={testimonial4} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section> */}
      {/*     <StatutoryWarningPreviewCarousel /> */}
      {/* </section> */}
      {/* <section> */}
      {/*     <BlogPreviewCarousel /> */}
      {/* </section> */}
      {/* <section className="partners"> */}
      {/*   <h3 className="heading">Few of Our Partners</h3> */}
      {/*   <p className="intro"> */}
      {/*     Empowering Your Financial Journey Through Our Trusted Partnerships */}
      {/*   </p> */}
      {/*   <div className="logos"> */}
      {/*     <Slider {...partnerSettings}> */}
      {/*       {logos.map((logo, index) => ( */}
      {/*         <div key={index} className="logo-container"> */}
      {/*           <img */}
      {/*             src={logo} */}
      {/*             alt={`Company Logo ${index + 1}`} */}
      {/*             className="logo-image" */}
      {/*             draggable="no" */}
      {/*           /> */}
      {/*         </div> */}
      {/*       ))} */}
      {/*     </Slider> */}
      {/*   </div> */}
      {/* </section> */}
    </div>
  );
};

export default Home;
